// نظام الأصوات الموسيقية لتطبيق وِداد
// Sound Manager for Wedad App

class SoundManager {
  constructor() {
    this.audioContext = null;
    this.enabled = localStorage.getItem('soundEnabled') !== 'false';
    this.volume = parseFloat(localStorage.getItem('soundVolume') || '0.5');
  }

  // تهيئة AudioContext
  init() {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    return this.audioContext;
  }

  // تفعيل/إيقاف الصوت
  toggle() {
    this.enabled = !this.enabled;
    localStorage.setItem('soundEnabled', this.enabled);
    return this.enabled;
  }

  // تغيير مستوى الصوت
  setVolume(vol) {
    this.volume = Math.max(0, Math.min(1, vol));
    localStorage.setItem('soundVolume', this.volume);
  }

  // تشغيل نغمة موسيقية باستخدام Web Audio API
  playTone(frequency, duration, type = 'sine', fadeOut = true) {
    if (!this.enabled) return;

    try {
      const ctx = this.init();
      if (ctx.state === 'suspended') {
        ctx.resume();
      }

      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);

      oscillator.frequency.value = frequency;
      oscillator.type = type;

      gainNode.gain.setValueAtTime(this.volume * 0.3, ctx.currentTime);
      
      if (fadeOut) {
        gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
      }

      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + duration);
    } catch (e) {
      console.log('Sound error:', e);
    }
  }

  // تشغيل سلسلة نغمات
  playMelody(notes, noteDuration = 0.15) {
    if (!this.enabled) return;

    notes.forEach((note, index) => {
      setTimeout(() => {
        this.playTone(note.freq, note.duration || noteDuration, note.type || 'sine');
      }, index * (noteDuration * 1000 + 50));
    });
  }

  // 🎶 موسيقى ترحيب رومانسية جميلة
  playWelcomeMelody() {
    if (!this.enabled) return;

    const melody = [
      { freq: 523.25, duration: 0.25 },  // C5
      { freq: 587.33, duration: 0.15 },  // D5
      { freq: 659.25, duration: 0.25 },  // E5
      { freq: 698.46, duration: 0.15 },  // F5
      { freq: 783.99, duration: 0.35 },  // G5
      { freq: 659.25, duration: 0.2 },   // E5
      { freq: 783.99, duration: 0.15 },  // G5
      { freq: 1046.50, duration: 0.5 },  // C6
    ];
    this.playMelody(melody, 0.18);
  }

  // 🎉 صوت إنهاء الملف الشخصي - نغمة احتفالية
  playProfileComplete() {
    const melody = [
      { freq: 523.25, duration: 0.15 },  // C5
      { freq: 659.25, duration: 0.15 },  // E5
      { freq: 783.99, duration: 0.15 },  // G5
      { freq: 1046.50, duration: 0.3 },  // C6
    ];
    this.playMelody(melody);
  }

  // 💬 صوت رسالة جديدة - نغمة ناعمة
  playNewMessage() {
    const melody = [
      { freq: 880, duration: 0.1 },      // A5
      { freq: 1108.73, duration: 0.15 }, // C#6
    ];
    this.playMelody(melody);
  }

  // 💕 صوت توافق/اقتراح جديد - نغمة رومانسية
  playMatch() {
    const melody = [
      { freq: 392, duration: 0.2 },    // G4
      { freq: 493.88, duration: 0.2 }, // B4
      { freq: 587.33, duration: 0.2 }, // D5
      { freq: 783.99, duration: 0.35 }, // G5
    ];
    this.playMelody(melody);
  }

  // ✅ صوت قبول الطلب - نغمة سعيدة
  playRequestAccepted() {
    const melody = [
      { freq: 523.25, duration: 0.12 }, // C5
      { freq: 587.33, duration: 0.12 }, // D5
      { freq: 659.25, duration: 0.12 }, // E5
      { freq: 783.99, duration: 0.25 }, // G5
      { freq: 1046.50, duration: 0.3 }, // C6
    ];
    this.playMelody(melody);
  }

  // 📩 صوت طلب تواصل جديد
  playNewRequest() {
    const melody = [
      { freq: 659.25, duration: 0.15 }, // E5
      { freq: 783.99, duration: 0.15 }, // G5
      { freq: 987.77, duration: 0.2 },  // B5
    ];
    this.playMelody(melody);
  }

  // 👁️ صوت زيارة الملف الشخصي
  playProfileVisit() {
    const melody = [
      { freq: 440, duration: 0.1 },     // A4
      { freq: 554.37, duration: 0.15 }, // C#5
    ];
    this.playMelody(melody);
  }

  // 🔔 صوت إشعار عام
  playNotification() {
    this.playTone(800, 0.15, 'sine');
    setTimeout(() => this.playTone(1000, 0.2, 'sine'), 150);
  }

  // ❌ صوت خطأ
  playError() {
    this.playTone(200, 0.3, 'sawtooth');
  }

  // ✨ صوت نجاح عام
  playSuccess() {
    const melody = [
      { freq: 523.25, duration: 0.1 }, // C5
      { freq: 659.25, duration: 0.15 }, // E5
    ];
    this.playMelody(melody);
  }

  // 🖱️ صوت النقر
  playClick() {
    this.playTone(1000, 0.05, 'sine');
  }

  // 💝 صوت قلب/إعجاب
  playHeart() {
    const melody = [
      { freq: 698.46, duration: 0.1 },  // F5
      { freq: 880, duration: 0.15 },    // A5
      { freq: 1046.50, duration: 0.2 }, // C6
    ];
    this.playMelody(melody);
  }

  // 📤 صوت إرسال رسالة
  playSend() {
    this.playTone(600, 0.08, 'sine');
    setTimeout(() => this.playTone(800, 0.1, 'sine'), 80);
  }

  // 🔓 صوت فتح/دخول
  playUnlock() {
    const melody = [
      { freq: 440, duration: 0.1 },     // A4
      { freq: 554.37, duration: 0.1 },  // C#5
      { freq: 659.25, duration: 0.15 }, // E5
    ];
    this.playMelody(melody);
  }
  // 🌙 صوت تبديل الوضع الليلي
  playThemeSwitch() {
    if (!this.enabled) return;
    const melody = [
      { freq: 392, duration: 0.08 },   // G4
      { freq: 523.25, duration: 0.12 }, // C5
    ];
    this.playMelody(melody, 0.08);
  }

  // 🔍 صوت البحث
  playSearch() {
    if (!this.enabled) return;
    const melody = [
      { freq: 587.33, duration: 0.08 }, // D5
      { freq: 783.99, duration: 0.08 }, // G5
      { freq: 987.77, duration: 0.12 }, // B5
    ];
    this.playMelody(melody, 0.06);
  }

  // 📑 صوت تبديل التاب
  playTabSwitch() {
    if (!this.enabled) return;
    this.playTone(700, 0.06, 'sine');
  }

  // 📤 صوت إرسال طلب تواصل
  playConnectionSent() {
    if (!this.enabled) return;
    const melody = [
      { freq: 523.25, duration: 0.1 },  // C5
      { freq: 659.25, duration: 0.1 },  // E5
      { freq: 783.99, duration: 0.1 },  // G5
      { freq: 1046.50, duration: 0.2 }, // C6
    ];
    this.playMelody(melody, 0.1);
  }

  // 📋 صوت نسخ
  playCopy() {
    if (!this.enabled) return;
    this.playTone(900, 0.06, 'sine');
    setTimeout(() => this.playTone(1200, 0.08, 'sine'), 60);
  }
}

// إنشاء instance واحد
const soundManager = new SoundManager();

// تصدير الدوال
export const playProfileComplete = () => soundManager.playProfileComplete();
export const playNewMessage = () => soundManager.playNewMessage();
export const playMatch = () => soundManager.playMatch();
export const playRequestAccepted = () => soundManager.playRequestAccepted();
export const playNewRequest = () => soundManager.playNewRequest();
export const playProfileVisit = () => soundManager.playProfileVisit();
export const playNotification = () => soundManager.playNotification();
export const playError = () => soundManager.playError();
export const playSuccess = () => soundManager.playSuccess();
export const playClick = () => soundManager.playClick();
export const playWelcomeMelody = () => soundManager.playWelcomeMelody();
export const playHeart = () => soundManager.playHeart();
export const playSend = () => soundManager.playSend();
export const playUnlock = () => soundManager.playUnlock();
export const playThemeSwitch = () => soundManager.playThemeSwitch();
export const playSearch = () => soundManager.playSearch();
export const playTabSwitch = () => soundManager.playTabSwitch();
export const playConnectionSent = () => soundManager.playConnectionSent();
export const playCopy = () => soundManager.playCopy();
export const toggleSound = () => soundManager.toggle();
export const setVolume = (vol) => soundManager.setVolume(vol);
export const isSoundEnabled = () => soundManager.enabled;

export default soundManager;
